export enum FileMimeByExt {
	png = 'image/png',
	jpg = 'image/jpeg',
	xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	xls = 'application/vnd.ms-excel',
	docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	pdf = 'application/pdf',
	json = 'application/json',
}

export enum FileUploaderVariant {
	secondary = 'secondary',
}

export interface FileListItem {
	fileId: number
	file: File | null
	id: string
	loadingPercent: number
	destroy: () => void
	download?: () => void
}